import React, { Component } from 'react';

class About extends Component {
   
   renderText(origText, results) {
      if (origText.aboutMe !== undefined){       
         var text = origText['aboutMe'];
         var substring1  = "UBC Math Department"; 
         var idx1 = text.indexOf(substring1);
         while (idx1>0){
            results.push(text.substring(0, idx1));
            results.push(<a href={"https://www.math.ubc.ca"}>{substring1+" "}</a>)
            idx1 = text.indexOf(substring1, (idx1 + 2));
         }

         var substring2  = "Prof. Tai-Peng Tsai";
         results.forEach(function (item, index) {
            var idx2 = text.indexOf(substring2);
            while (idx2>0){
               results.push(text.substring(0, idx2));
               results.push(<a href={"https://www.math.ubc.ca"}>{substring2+" "}</a>)
               idx2 = text.indexOf(substring2, (idx2 + 1));
            }
         });
       
      // var idx2 = text.indexOf(substring2);
      // while (idx2>0){
      //    results.push(text.substring(0, idx2));
      //    results.push(<a href={"https://www.math.ubc.ca"}>{substring2}</a>)
      //    idx2 = text.indexOf(substring2, (idx2 + 1));
      // }

      //   var substring3  = "UBC Math Department"; 
      //   var idx1 = text.indexOf(substring1);
      //   while (idx1>0){
      //      results.push(text.substring(0, idx));
      //      results.push(<a href={"https://www.math.ubc.ca"}>{substring1}</a>)
      //      idx1 = text.indexOf(substring1, (idx1 + 1));
      //   }
      }
      
        
      console.log(results);
      return results
    }

  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var chname = this.props.data.chname;
      var department = this.props.data.address.department;
      var affiliation = this.props.data.address.affiliation;
      var profilepic= "images/"+this.props.data.image;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var office= this.props.data.office;
      var email = this.props.data.email;
      var phone = this.props.data.phone;
      var resumeDownload = this.props.data.resumedownload;
      var aboutMe = this.props.data.aboutMe;
    }

    let results = [];
   // let aboutMeWithLink = <p>123 <a href="https://www.pluralsight.com/guides/how-to-render-%22a%22-with-optional-href-in-react">LinkedIn handle</a></p>;
   // console.log(aboutMe);
   // let aboutMeWithLink = this.renderText(aboutMe);
   //  if aboutMe.includes(){

   //  }<p>{aboutMe}</p>; 

    return (
      <section id="about">
      <div className="row banner">
         {/* <div className="three columns">
            <img className="profile-pic"  src={profilepic} alt="Chen-Chih Profile Pic" />
         </div> */}
         <div className="banner-text">
            <h2>About Me</h2>
            <p>
               I am an Assistant Professor in the <a href="https://math.mtsu.edu">Department of Mathematical Sciences</a> at <a href="https://www.mtsu.edu">Middle Tennessee State University (MTSU)</a>. 
               Previously, I was a Postdoctoral Scholar in the <a href="https://math.msu.edu">Department of Mathematics</a> at <a href="https://msu.edu">Michigan State University (MSU)</a>, where I worked with Prof. <a href="https://users.math.msu.edu/users/weig/">Guowei Wei</a>. 
               From 2021 to 2024, I was a Postdoctoral Research Scientist in the <a href="https://www.math.columbia.edu">Department of Mathematics</a> at <a href="https://www.columbia.edu">Columbia University</a>, working with Prof. <a href="http://www.columbia.edu/~miw2103/">Michael I. Weinstein</a> and supported in part by the <a href="https://www.simonsfoundation.org">Simons Foundation</a>. 
               In July 2021, I completed my Ph.D. in the <a href="https://www.math.ubc.ca">Department of Mathematics</a> at the <a href="https://www.ubc.ca">University of British Columbia (UBC)</a> under the guidance of Prof. <a href="http://www.math.ubc.ca/~ttsai/">Tai-Peng Tsai</a> and Prof. <a href="https://www.math.ubc.ca/~jcwei/">Juncheng Wei</a>.
               <br></br>
               <h2></h2>
               My primary research interests lie in the analysis of nonlinear partial differential equations and applied mathematics, particularly problems arising in fluid dynamics, physics, and biology. 
               My research includes free-boundary problems for gas bubbles in liquids, with an emphasis on nonlinear dynamics, stability, thermal effects, and interface geometry; 
               fluid-related coupled systems, including the Navier–Stokes equations, chemotaxis–fluid models, nematic liquid crystal flows, magnetohydrodynamics, and viscoelastic fluids; and 
               data-driven and physics-informed variational methods for learning governing laws in stochastic systems with non-gradient structures.
            </p>
            <div className="row">
               <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                     <span>{department}</span><br />
                     <span>{affiliation}</span><br />
						   <span>{street}<br />
						         {city}, {state} {zip}
                   </span><br /><br />
						   <span>{office}</span><br />
                     <span>{email}</span><br />
                     <span>{phone}</span>
					   </p>
               </div>
               {/* <div className="columns download">
                  <p>
                     <a href={resumeDownload} className="button"><i className="fa fa-download"></i>Download Resume</a>
                  </p>
               </div> */}
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;
